<template>
    <!-- 编辑界面 -->
    <el-drawer :title="title" :visible.sync="editFormVisible" @click="closeDialog" :size="600" :wrapperClosable="false"
        :modal="false" :destroy-on-close="true" class="margin_top_40">
        <el-form label-width="8.75rem" :model="editForm" ref="editForm" :rules="rules">
            <el-form-item label="所属门店" prop="storeKeyId">
                <el-select v-model="editForm.storeKeyId" placeholder="请选择门店" clearable size="small" class="input_200px">
                    <el-option v-for="item in storeList" :label="item.value" :value="item.keyId"
                        :key="item.keyId"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div class="drawer-footer">
            <el-button size="small" icon="el-icon-check" :loading="loading" class="title"
                @click="submitForm('editForm')">
                保存
            </el-button>
        </div>
    </el-drawer>
</template>

<script>
import {
    AddStoreCostMain
} from "@/api/storeCostApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
export default {
    data() {
        return {
            title: "",
            loading: false, //是显示加载
            editFormVisible: false, //控制编辑页面显示与隐藏
            editForm: {
                keyId: "",
                storeKeyId: "",
            },
            storeList: [],
            // rules 表单验证
            rules: {
                storeKeyId: [
                    {
                        required: true,
                        message: "请选择门店",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    computed: {},
    watch: {},

    methods: {
        //显示编辑界面
        editShow(row) {
            if (row != undefined && row != "undefined") {
                this.title = "编辑";
                let parmer = {
                    keyId: row.keyId,
                };
            } else {
                this.title = "新增";
                this.$data.editForm = this.$options.data.call(this).editForm;
                this.editFormVisible = true;
            }
        },
        // 编辑、增加页面保存方法
        submitForm(editData) {
            this.$refs[editData].validate((valid) => {
                if (valid) {
                    AddStoreCostMain({
                        keyId: this.editForm.storeKeyId,
                    })
                        .then((res) => {
                            if (res.code == 1) {
                                this.$parent.getListData();
                                this.$message({
                                    type: "success",
                                    message: "门店备用金保存成功！",
                                });
                                this.editFormVisible = false;
                                this.loading = false;
                            } else {
                                this.$message({
                                    type: "info",
                                    message: res.msg,
                                });
                            }
                        })
                        .catch((err) => {
                            this.editFormVisible = false;
                            this.loading = false;
                            this.$message.error("门店备用金保存失败，请稍后再试！");
                        });
                } else {
                    return false;
                }
            });
        },
        // 关闭编辑、增加弹出框
        closeDialog() {
            this.editFormVisible = false;
            this.$data.editForm = this.$options.data.call(this).editForm;
        },
        // 获取所属门店
        GetOrgInfoListByConfig() {
            const paramer = {
                key: 1,
            };
            GetOrgInfoListByConfig(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.storeList = [];
                        if (res.code == 1) {
                            res.data.forEach((item) => {
                                this.storeList.push({
                                    keyId: item.keyId,
                                    value: item.name + '【' + item.remark2 + '】',
                                });
                            });
                        } else {
                            this.$message.error(res.msg);
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取门店信息失败!");
                });
        },
    },
    created() {
        this.GetOrgInfoListByConfig();
    },
    mounted() { },
    components: {},
};
</script>
<style scoped>
.wip {
    width: 200px !important;
}
</style>